import { PoisonInteractor, PoisonRequest, PoisonStructRequest } from "../../Coordinator/Poison/PoisonInteractor";

export class PoisonViewModel {
	private interactor: PoisonInteractor;

	constructor() {
		this.interactor = new PoisonInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new PoisonRequest(
			obj["sgepveneno"] ? parseInt(obj["sgepveneno"]) : 0,
			obj["nome"] ? obj["nome"] : "",
			obj["codigo"] ? obj["codigo"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new PoisonStructRequest(obj["sgepveneno"] ? parseInt(obj["sgepveneno"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}